<template>
    <a-modal
        class="modal epic-default"
        :title="$t('cia.vehicle_checker.modal.titles.upload')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '720px' }"
    >
        <template #footer>
            <a-button
                key="submit"
                type="primary"
                data-cy="user-import-submit"
                :loading="processing"
                :disabled="file_fist.length == 0"
                @click="handleSubmit"
            >
                {{ $t('cia.vehicle_checker.modal.buttons.submit') }}
            </a-button>
        </template>
        <a-upload-dragger
            name="file"
            data-cy="user-import-drag"
            @remove="handleRemove"
            :file-list="file_fist"
            :multiple="true"
            :before-upload="beforeUpload"
        >
            <p class="ant-upload-drag-icon">
                <InboxOutlined />
            </p>
            <p class="ant-upload-text">{{ $t('cia.vehicle_checker.modal.body') }}</p>
            <p class="ant-upload-hint">{{ $t('cia.vehicle_checker.modal.hint') }}</p>
        </a-upload-dragger>
    </a-modal>
</template>

<script>
import UiCheckbox from '@/components/ui/Checkbox.vue';
import { InboxOutlined } from '@ant-design/icons-vue';

export default {
    components: { UiCheckbox, InboxOutlined },
    data() {
        return {
            modal_visible: false,
            is_reactivation: null,
            file_fist: [],
            file_lLimit: -1,
        };
    },
    props: {
        processing: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        showModal() {
            this.file_fist = [];
            this.is_reactivation = null;
            this.modal_visible = true;
        },
        hideModal() {
            this.modal_visible = false;
        },
        handleSubmit() {
            const { file_fist } = this;
            const formData = new FormData();

            formData.append('upload_file', file_fist[0]);

            this.$emit('formSubmit', formData);
        },
        handleRemove(file) {
            const index = this.file_fist.indexOf(file);
            const new_file_list = this.file_fist.slice();

            new_file_list.splice(index, 1);

            this.file_fist = new_file_list;
        },
        beforeUpload(file) {
            const isTSV = file.type === 'text/plain';
            const isCSV = file.type === 'text/csv';

            if (isTSV || isCSV) {
                if (this.file_fist.some((value) => value.name.toLowerCase() == file.name.toLowerCase())) {
                    this.$notification.error({
                        message: this.$t('validation.exists_already', { attribute: 'file' }),
                    });
                } else {
                    this.file_fist = [...this.file_fist, file].slice(this.file_lLimit);
                }
            } else {
                this.$notification.error({
                    message: this.$t('validation.mimes', { attribute: 'File', values: 'TXT or CSV' }),
                });
            }
            return false;
        },
    },
};
</script>
